import { request } from '../api';
import {
  TQuizzAnswer,
  TQuizzCorrectAnswer,
  TQuizzResult,
  useQuizzStore,
} from '../stores';
import { storeDidCatch } from '../utils';

export const getQuizzAvailableState = async () => {
  try {
    const { setAvailableState } = useQuizzStore.getState();

    const { data: { data } = {} } = await request.get('/quiz/availability');

    setAvailableState(data.availableAt || null, data.availableUntil || null);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getQuizzAvailableState]', error);
  }
};

export const getRandomQuizz = async () => {
  try {
    const { setQuizzes } = useQuizzStore.getState();

    const { data: { data: { quizzes } = {} } = {} } =
      await request.get('/quiz/start');

    setQuizzes(quizzes);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getRandomQuizz]', error);
  }
};

export const submitQuizzAnswer = async (quizzAnswer: TQuizzAnswer) => {
  try {
    const { data: { data } = {} } = await request.post(
      '/quiz/submit-answer',
      quizzAnswer,
    );

    return data as TQuizzCorrectAnswer;
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [submitQuizzAnswer]', error);
  }
};

export const submitQuizzAnswerBulk = async (quizzAnswers: TQuizzAnswer[]) => {
  try {
    const { data: { data } = {} } = await request.post(
      '/quiz/submit-answers-bulk',
      {
        answers: quizzAnswers,
      },
    );

    return data as TQuizzResult;
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [submitQuizzAnswerBulk]', error);
  }
};
